import styled from 'styled-components';
import StyledCheckbox from '../checkbox/StyledCheckbox';
import SortingIcon from '../svgIcons/SortingIcon';
import StyledToolTip from '../styledComponents/StyledToolTip';
import InfoIcon from '../svgIcons/InfoIcon';

const TableHeader = ({
  sortColumn,
  checkBox,
  setSelectedRows,
  selectedRows,
  columns,
  data,
  onSort,
  handleSelectAll,
  formListings,
  type = ''
}) => {
  const raiseSort = (path) => {
    if (!path) return;
    const sort = { ...sortColumn };
    if (sort.path === path)
      sort.order = sortColumn.order === 'ASC' ? 'DESC' : 'ASC';
    else {
      sort.path = path;
      sort.order = 'ASC';
    }
    onSort(sort);
  };

  const renderSortIcon = (column) => {
    if (column.path !== sortColumn.path) return null;
    if (column.path === 'hired') return null;
    if (sortColumn.order === 'DESC') return <SortingIcon />;
    return <SortingIcon rotate="up" />;
  };

  return (
    <THead>
      <tr>
        {checkBox &&  (
          <th style={{ width: '15px' }}>
            
            {!formListings &&<StyledTableCheck
              // className={`ms-2 mb-1 me-2`}
              size={15}
              value={selectedRows.length === data.length}
              onChange={handleSelectAll}
            />}
          </th>
        )}
        {columns?.map((column) => (
          <th
            style={{ width: column.width }}
            className={column.alignHeader}
            key={Math.random()}
            onClick={() => onSort && raiseSort(column.path)}
          >
             {column.label} {renderSortIcon(column)}
             {column?.tooltip ? <StyledToolTip title={column?.tooltip} childrenClass={'ms-1'} applyStyle={false}><InfoIcon size='13'/></StyledToolTip> : null}
            
          </th>
        ))}
      </tr>
    </THead>
  );
};

const THead = styled.thead`
background-color: ${({theme})=> theme?.tableHeaderBg} !important;

`

const StyledTableCheck = styled(StyledCheckbox)`
   margin: 8px;
   margin-bottom:10px;
   margin-top: 0px
`;

export default TableHeader;